import React, { useState } from "react";
import ApiService from "../services/ApiService";
import "./CouponInput.css";

const CouponInput = ({
  onCouponApply,
  onCouponRemove,
  appliedCoupon,
  originalAmount,
}) => {
  const [couponCode, setCouponCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const validateCoupon = async () => {
    if (!couponCode.trim()) {
      setError("Please enter a coupon code");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const data = await ApiService.validateCoupon(couponCode);

      if (data.success) {
        onCouponApply({
          code: couponCode.toUpperCase(),
          discountAmount: data.data.discountAmount,
          coupon: data.data.coupon,
        });
        setCouponCode("");
        setError("");
      } else {
        setError(data.message || "Invalid coupon code");
      }
    } catch (error) {
      console.error("Error validating coupon:", error);
      setError(error.message || "Failed to validate coupon. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveCoupon = () => {
    onCouponRemove();
    setError("");
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      validateCoupon();
    }
  };

  if (appliedCoupon) {
    const discountAmount = parseFloat(appliedCoupon.discountAmount);
    const finalAmount = Math.max(0, originalAmount - discountAmount);

    return (
      <div className="coupon-input-container">
        <div className="applied-coupon">
          <div className="coupon-success">
            <div className="coupon-icon">✓</div>
            <div className="coupon-details">
              <div className="coupon-code-applied">
                Coupon "{appliedCoupon.code}" applied
              </div>
              <div className="coupon-savings">
                You saved ₹{discountAmount.toFixed(2)}
              </div>
            </div>
            <button
              className="remove-coupon-btn"
              onClick={handleRemoveCoupon}
              title="Remove coupon"
            >
              ×
            </button>
          </div>

          <div className="price-breakdown">
            <div className="price-row">
              <span>Original Amount:</span>
              <span>₹{originalAmount.toFixed(2)}</span>
            </div>
            <div className="price-row discount">
              <span>Coupon Discount:</span>
              <span>-₹{discountAmount.toFixed(2)}</span>
            </div>
            <div className="price-row total">
              <span>Final Amount:</span>
              <span>₹{finalAmount.toFixed(2)}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="coupon-input-container">
      <div className="coupon-section">
        <h4>Have a coupon code?</h4>
        <div className="coupon-input-group">
          <input
            type="text"
            placeholder="Enter coupon code"
            value={couponCode}
            onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
            onKeyPress={handleKeyPress}
            className="coupon-input"
            disabled={loading}
          />
          <button
            onClick={validateCoupon}
            disabled={loading || !couponCode.trim()}
            className="apply-coupon-btn"
          >
            {loading ? "Validating..." : "Apply"}
          </button>
        </div>
        {error && <div className="coupon-error">{error}</div>}
      </div>
    </div>
  );
};

export default CouponInput;
